export const VALIDATE_FEEDBACK_FORM = 'VALIDATE_FEEDBACK_FORM';

export function validateFeedBackFormAction() {
    return {
      type: VALIDATE_FEEDBACK_FORM
    }
  }